export default "__VITE_ASSET__DYQInGaS__"